var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReassignRfqDocsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8255_58074)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.98953 41.584C3.72002 41.584 2.65527 42.5054 2.65527 43.6111V65.2542C2.65527 66.3599 3.69955 67.2813 4.98953 67.2813H19.7322C19.9165 67.2813 20.1008 67.2198 20.2441 67.1175L25.6702 63.0632C25.834 62.9404 25.9364 62.7561 25.9364 62.5513V43.6111C25.9364 42.5054 24.8921 41.584 23.6021 41.584H4.98953ZM4.98953 42.9354H23.6226C24.0731 42.9354 24.4007 43.2221 24.4007 43.6111V61.1999H21.3088C20.0393 61.1999 18.9746 62.1213 18.9746 63.227V65.9299H4.98953C4.53906 65.9299 4.21144 65.6432 4.21144 65.2542V43.6111C4.23192 43.2221 4.55953 42.9354 4.98953 42.9354ZM21.3088 62.5513H23.9912L20.5308 65.1313V63.227C20.5308 62.838 20.8584 62.5513 21.3088 62.5513Z",
    fill: "#02475E",
    stroke: "#02475E",
    strokeWidth: 1.33913,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6575 37.5098C8.38799 37.5098 7.32324 38.4312 7.32324 39.5369V39.9464C7.32324 40.315 7.67133 40.6221 8.10133 40.6221C8.53132 40.6221 8.87941 40.315 8.87941 39.9464V39.5369C8.87941 39.1478 9.20703 38.8612 9.6575 38.8612H28.2906C28.7411 38.8612 29.0687 39.1478 29.0687 39.5369V61.1799C29.0687 61.7533 28.6182 61.8556 28.0039 61.8556C27.5739 61.8556 27.2258 62.1628 27.2258 62.5313C27.2258 62.8999 27.5739 63.2071 28.0039 63.2071C29.7444 63.2071 30.6248 62.4085 30.6248 61.1799V39.5574C30.6248 38.4517 29.5806 37.5302 28.2906 37.5302H9.6575V37.5098Z",
    fill: "#02475E",
    stroke: "#02475E",
    strokeWidth: 1.33913,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3876 33.7207C13.1591 33.7207 12.1353 34.6012 12.1353 35.6864V36.0959C12.1353 36.4645 12.4629 36.7511 12.8929 36.7511C13.3024 36.7511 13.6505 36.4645 13.6505 36.0959V35.7069C13.6505 35.3383 13.9781 35.0516 14.4081 35.0516H32.4679C32.8978 35.0516 33.2255 35.3383 33.2255 35.7069V56.6947C33.2255 57.268 32.7955 57.3499 32.1812 57.3499C31.7717 57.3499 31.4236 57.6366 31.4236 58.0052C31.4236 58.3737 31.7512 58.6604 32.1812 58.6604C33.8602 58.6604 34.7202 57.9028 34.7202 56.6947V35.7069C34.7202 34.6216 33.6964 33.7412 32.4679 33.7412H14.3876V33.7207Z",
    fill: "#02475E",
    stroke: "#02475E",
    strokeWidth: 1.33913,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3235 46.3125C6.8935 46.3125 6.54541 46.6196 6.54541 46.9882C6.54541 47.3568 6.8935 47.6639 7.3235 47.6639H21.2881C21.7181 47.6639 22.0662 47.3568 22.0662 46.9882C22.0662 46.6196 21.7181 46.3125 21.2881 46.3125H7.3235Z",
    fill: "#02475E",
    stroke: "#02475E",
    strokeWidth: 1.33913,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3235 50.3672C6.8935 50.3672 6.54541 50.6743 6.54541 51.0429C6.54541 51.4115 6.8935 51.7186 7.3235 51.7186H21.2881C21.7181 51.7186 22.0662 51.4115 22.0662 51.0429C22.0662 50.6743 21.7181 50.3672 21.2881 50.3672H7.3235Z",
    fill: "#02475E",
    stroke: "#02475E",
    strokeWidth: 1.33913,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3235 54.4199C6.8935 54.4199 6.54541 54.7271 6.54541 55.0956C6.54541 55.4642 6.8935 55.7713 7.3235 55.7713H21.2881C21.7181 55.7713 22.0662 55.4642 22.0662 55.0956C22.0662 54.7271 21.7181 54.4199 21.2881 54.4199H7.3235Z",
    fill: "#02475E",
    stroke: "#02475E",
    strokeWidth: 1.33913,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3235 58.4961C6.8935 58.4961 6.54541 58.8032 6.54541 59.1718C6.54541 59.5404 6.8935 59.8475 7.3235 59.8475H16.9267C17.3567 59.8475 17.7048 59.5404 17.7048 59.1718C17.7048 58.8032 17.3567 58.4961 16.9267 58.4961H7.3235Z",
    fill: "#02475E",
    stroke: "#02475E",
    strokeWidth: 1.33913,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.745 40.6426C72.1717 40.6426 71.7212 41.0521 71.7212 41.564C71.7212 42.0759 72.1921 42.4854 72.745 42.4854H91.2757C91.849 42.4854 92.2995 42.0759 92.2995 41.564C92.2995 41.0521 91.8286 40.6426 91.2757 40.6426H72.745Z",
    fill: "#F78670",
    stroke: "#F78670",
    strokeWidth: 2.17911,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.745 46.2109C72.1717 46.2109 71.7212 46.6205 71.7212 47.1324C71.7212 47.6443 72.1921 48.0538 72.745 48.0538H91.2757C91.849 48.0538 92.2995 47.6443 92.2995 47.1324C92.2995 46.6205 91.8286 46.2109 91.2757 46.2109H72.745Z",
    fill: "#F78670",
    stroke: "#F78670",
    strokeWidth: 2.17911,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.745 51.7812C72.1717 51.7812 71.7212 52.1908 71.7212 52.7027C71.7212 53.2146 72.1921 53.6241 72.745 53.6241H91.2757C91.849 53.6241 92.2995 53.2146 92.2995 52.7027C92.2995 52.1908 91.8286 51.7812 91.2757 51.7812H72.745Z",
    fill: "#F78670",
    stroke: "#F78670",
    strokeWidth: 2.17911,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.745 57.3496C72.1717 57.3496 71.7212 57.7591 71.7212 58.271C71.7212 58.7829 72.1921 59.1924 72.745 59.1924H85.5015C86.0748 59.1924 86.5253 58.7829 86.5253 58.271C86.5253 57.7591 86.0543 57.3496 85.5015 57.3496H72.745Z",
    fill: "#F78670",
    stroke: "#F78670",
    strokeWidth: 2.17911,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6017 33.7207H92.0743C94.47 33.7207 96.3947 35.4612 96.3947 37.6111V63.3698C96.3947 65.5198 94.4495 67.2603 92.0743 67.2603H72.6017C70.206 67.2603 68.2812 65.5198 68.2812 63.3698V42.6482",
    stroke: "#F78670",
    strokeWidth: 3.45959,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2456 52.6227C45.1631 58.4379 54.664 58.3355 60.4791 52.418",
    stroke: "#F78670",
    strokeWidth: 2.73929,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8555 50.1035L62.1587 51.1068L60.5207 56.6558",
    stroke: "#F78670",
    strokeWidth: 2.73929,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8255_58074"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReassignRfqDocsIcon);
export default __webpack_public_path__ + "static/media/reassignRfqDocsIcon.9f86c7623fd98ba6ceb4f1a58c21074a.svg";
export { ForwardRef as ReactComponent };